import React from 'react'

export const Context = React.createContext({}) // OP: FixIt

export default Context
